import { render, staticRenderFns } from "./companyInformation.vue?vue&type=template&id=010e6dfa&scoped=true"
import script from "./companyInformation.vue?vue&type=script&lang=js"
export * from "./companyInformation.vue?vue&type=script&lang=js"
import style0 from "./companyInformation.vue?vue&type=style&index=0&id=010e6dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010e6dfa",
  null
  
)

export default component.exports